import React from 'react';
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import { brand } from '../branding';

/**
 * Shown when a user is authenticated but has NO active membership — almost
 * always a parent who was provisioned by the add-student flow but hasn't
 * completed their invite-signup yet (their membership stays dormant until
 * they do). Without this they'd land on the staff Dashboard, whose API calls
 * 403, and see unexplained errors.
 *
 * Read-only, dependency-free: it never calls the API (the user has no context
 * to authorize a call), so it can't itself error.
 */
const NoActiveMembership: React.FC = () => {
  return (
    <div
      className="min-h-[60vh] flex items-center justify-center px-4"
      data-testid="no-active-membership"
    >
      <div className="max-w-md w-full bg-white shadow rounded-lg p-6 text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-amber-100">
          <EnvelopeIcon className="h-6 w-6 text-amber-700" />
        </div>
        <h2 className="text-lg font-semibold text-gray-900">Almost there</h2>
        <p className="mt-2 text-sm text-gray-600">
          Your account isn’t linked to a school yet. If you were invited by your child’s school,
          please open the link in your invitation email to finish setting up your account.
        </p>
        <p className="mt-4 text-xs text-gray-500">
          Already finished signing up? Try logging out and back in. If the problem persists, contact
          your school and they can resend your invitation from {brand.name}.
        </p>
      </div>
    </div>
  );
};

export default NoActiveMembership;
